import { useEffect, useState } from "react";
import styles from "./Countries.module.scss";
import { CountriesService } from "../../../services/countries.service";
import { CountriesDataType } from "../../../interface/site.interface";
import { Base_Url } from "../../../constants/base_url";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const Countries = ({
  onCountrySelect,
}: {
  onCountrySelect: (countryName: string) => void;
}) => {
  const [activeBtn, setActiveBtn] = useState<number>(0);
const language = useSelector((state: RootState) => state.language.language);

  const [countries, setCountries] = useState<CountriesDataType[]>([]);
  useEffect(() => {
    CountriesService.getAllCountries().then((response) =>
      setCountries(response?.data?.original)
    );
  }, [language]);

  const handleCountryClick = (index: number, countryName: string) => {
    setActiveBtn(index);
    onCountrySelect(countryName);
  };

  return (
    <div className={styles.name_buttons}>
      <div className={styles.countries_name}>
        {countries?.map((country, index) => (
          <button
            key={index}
            className={`${styles.country_name} ${
              activeBtn === index ? styles.active_btn : ""
            }`}
            onClick={() => handleCountryClick(index, country.title)}
          >
            <img src={`${Base_Url}${country.image}`} alt={country.title} />
            <p>{country.title}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Countries;
